export default {"src":"/_next/static/media/home.07edd67d.svg","height":348,"width":688};